const inFlightPromises = new Map();

export function approveListKey(list) {
	return (Array.isArray(list) ? list : [])
		.map((item) => `${item.id}:${item.approved ? 1 : 0}`)
		.sort()
		.join("|");
}

export function runExclusive(key, run) {
	const existing = inFlightPromises.get(key);
	if (existing) return existing;

	const promise = Promise.resolve()
		.then(run)
		.finally(() => {
			inFlightPromises.delete(key);
		});

	inFlightPromises.set(key, promise);
	return promise;
}

export function createApprovalLock() {
	const keys = new Set();
	return {
		tryBegin(key) {
			const k = String(key);
			if (keys.has(k)) return false;
			keys.add(k);
			return true;
		},
		end(key) {
			keys.delete(String(key));
		},
		has(key) {
			return keys.has(String(key));
		},
	};
}

export function resetApprovalInFlightForTests() {
	inFlightPromises.clear();
}
